"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 30 19",
    width: props.size || props.width || "24px",
    id: "maestro",
    height: props.size || props.height || "24px"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.591 9.506c0-2.742 1.33-5.187 3.41-6.79A9.464 9.464 0 009.203.762C4.121.762 0 4.676 0 9.506s4.121 8.744 9.204 8.744A9.464 9.464 0 0015 16.294c-2.079-1.602-3.409-4.048-3.409-6.79",
    fill: "#EB001B"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.796.762A9.464 9.464 0 0015 2.716c2.079 1.603 3.409 4.048 3.409 6.79 0 2.741-1.33 5.187-3.41 6.79a9.47 9.47 0 005.797 1.953c5.083 0 9.204-3.914 9.204-8.743 0-4.83-4.121-8.744-9.204-8.744",
    fill: "#0099DF"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.409 9.506c0-2.742-1.33-5.187-3.41-6.79-2.078 1.603-3.408 4.048-3.408 6.79 0 2.741 1.33 5.187 3.409 6.79 2.079-1.603 3.409-4.049 3.409-6.79",
    fill: "#6B6ABE"
  })));
};
var _default = exports["default"] = SvgComponent;